export function applyDesignSystemClasses({
  html,
  designSystemRules = [],
}: {
  html: string;
  designSystemRules?: { tag: string; className: string }[];
}): string {
  if (!html.includes('<')) {
    return html;
  }

  const defaultDesignSystemRules = [
    { tag: 'a', className: 'webex-link' },
    { tag: 'ul', className: 'webex-list-disc' },
  ];

  const designSystemMappings = defaultDesignSystemRules.map(
    (defaultMapping) => {
      const override = designSystemRules.find(
        (custom) => custom.tag === defaultMapping.tag,
      );
      return override || defaultMapping;
    },
  );

  return designSystemMappings.reduce((processedHtml, { tag, className }) => {
    const pattern = new RegExp(`<${tag}([^>]*)>`, 'g');

    return processedHtml.replace(pattern, (match, attributes) => {
      if (attributes.includes('class="')) {
        return match.replace(/class="([^"]*)"/, `class="${className} $1"`);
      }

      return `<${tag}${attributes} class="${className}">`;
    });
  }, html);
}
